export default __webpack_public_path__ + "static/media/waving-hand-sign_1f44b 1.90ac5ca5.svg";